import { ReactNode } from "react";
import { Cookies } from "react-cookie";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { tokenKey } from "../constants/common";
import { useAuth } from "../context/authContext";

interface Props {
  children: ReactNode;
}

async function getToken() {
  const cookies = new Cookies();
  return await cookies.get(tokenKey);
}

const PrivateRoute = ({ children, ...rest }: Props & RouteProps) => {
  const { isAuthenticated } = useAuth();
  const token = getToken();

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated && !!token ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
